import BigNumber from 'bignumber.js';

export const DECIMAL_6 = 6 as const;
export const ROUND_DOWN = BigNumber.ROUND_DOWN;
